import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {H2} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {copyLinkToClipboard} from '@freckle/classroom/ts/common/helpers/copy-link-to-clipboard'
import {linkContent, referralLink} from './referral-program.module.scss'

type Props = {referralLink: string}

const LinkContent = (props: Props) => {
  const {t} = useSafeTranslation()
  const {referralLink} = props

  const onClickHandler = () => {
    copyLinkToClipboard(t, referralLink)
  }

  return (
    <div className={linkContent}>
      <input type="text" readOnly defaultValue={referralLink} />
      <button onClick={onClickHandler}>{t('REFERRAL_PROGRAM_REFERRAL_LINK_CTA')}</button>
    </div>
  )
}

const ReferralLink = (props: Props): React.ReactElement => {
  const {t} = useSafeTranslation()
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      className={referralLink}
    >
      <H2>{t('REFERRAL_PROGRAM_REFERRAL_LINK_HEADER')}</H2>
      <LinkContent {...props} />
    </Flex>
  )
}

export {ReferralLink}
